import React, { FC, ReactElement } from 'react';

import SubscribeCard from 'buyside/components/presentation/Subscribe/SubscribeCard';
import SubscribeCardSellingPoint from 'buyside/components/presentation/Subscribe/SubscribeCardSellingPoint';
import SubscribeFeaturesTable from './SubscribeFeaturesTable';

import { PaymentPlanValues, PlanInfo, STRIPE_PLANS } from 'interfaces/payment/plans';

import styles from './subscribeStyles.scss';

const Subscribe: FC<{
  isRetail: boolean;
  plans: PlanInfo[];
  subscriptions: Array<{
    isAutoRenewing: boolean;
    status: string;
  } | null> | null;
  userTier: PaymentPlanValues | null;
}> = ({ plans, isRetail, userTier }): ReactElement => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.cardsContainer}>
          {plans.map(
            ({ title, price, type, sellingPoints, name }, index): ReactElement => {
              return (
                <SubscribeCard
                  isCurrentTier={STRIPE_PLANS[name] === userTier}
                  isRetail={isRetail}
                  key={index}
                  price={price}
                  stripePlan={STRIPE_PLANS[name]}
                  title={title}
                  type={type}
                >
                  {sellingPoints.map(
                    (reason: { [key: string]: string[] }): ReactElement => {
                      const header = Object.keys(reason).toString();

                      return (
                        <SubscribeCardSellingPoint
                          key={header}
                          header={header}
                          subBullets={reason[header]}
                        />
                      );
                    }
                  )}
                </SubscribeCard>
              );
            }
          )}
        </div>
        {isRetail ? <SubscribeFeaturesTable /> : null}
      </div>
    </div>
  );
};

export default Subscribe;
